import { useDocumentTitle } from 'base/ui/document_title';
import { Rows } from 'base/ui/layout';
import { TextRegular, TextRegularLight, Title5 } from 'base/ui/typography';
import React from 'react';
import { ClipboardPayload, tryReadClipboardEvent } from './editor/clipboard';

export function ClipboardInspector() {
  const [payload, setPayload] = React.useState<ClipboardPayload | undefined>(
    undefined,
  );

  useDocumentTitle('Clipboard inspector - Relume');

  React.useEffect(() => {
    const callback = (e: ClipboardEvent) => {
      if (!e.clipboardData) return;
      tryReadClipboardEvent(e.clipboardData, (label) =>
        console.log('Failed to read site builder data'),
      ).then((v) => {
        console.log(v);
        v && setPayload(v);
      });
      const applicationJson = e.clipboardData.getData('application/json');
      if (applicationJson) {
        console.log('application/json', JSON.parse(applicationJson));
      }
    };
    document.addEventListener('paste', callback);
    return () => document.removeEventListener('paste', callback);
  }, []);

  return (
    <div style={{ userSelect: 'text' }}>
      <Rows spacing={16}>
        <Title5>Clipboard inspector tool</Title5>
        <TextRegularLight>
          The parsed clipboard data will be shown here.
        </TextRegularLight>
        <TextRegularLight>
          Webflow (application/json) data will be logged to the console.
        </TextRegularLight>
        {!payload && (
          <TextRegular color="red">Paste with Cmd/Ctrl-V</TextRegular>
        )}
        {payload && (
          <pre>
            <code>{JSON.stringify(payload, null, 2)}</code>
          </pre>
        )}
      </Rows>
    </div>
  );
}
